import { __r } from 'react-i18n';
import { prop, getSymbolFromCurrency } from '../../../utilities';

export enum cartRoutes {
  INDEX = 'routes:kosik',
  SECOND_STEP = 'routes:kosik/osobne-udaje',
  THIRD_STEP = 'routes:cart/dodanie-a-platba',
}

export const cartIndexRoute = __r('routes:kosik', '/kosik');
export const cartSecondStepRoute = __r(
  'routes:kosik/osobne-udaje',
  '/kosik/osobne-udaje',
);
export const cartThirdStepRoute = __r(
  'routes:cart/dodanie-a-platba',
  '/kosik/dodanie-a-platba',
);

export const remapDeliveryItem = (
  item: any,
  isB2B?: boolean,
): { id: number; name: string; price: string } => {
  const currency = prop(item, 'price.currency', 'EUR');
  const price = prop(item, 'price.price', 0);
  const priceWithoutVat = prop(item, 'price.priceWithoutVat', 0);
  const correctPrice = isB2B ? priceWithoutVat : price;
  const priceReadable =
    correctPrice > 0
      ? `${correctPrice} ${getSymbolFromCurrency(currency)}`
      : 'Zadarmo';

  return {
    ...item,
    id: prop(item, 'delivery_id'),
    name: prop(item, 'delivery_name'),
    price: priceReadable,
  };
};

export const remapPaymentItem = (
  item: any,
  isB2B?: boolean,
): { id: number; name: string; price: string } => {
  const currency = prop(item, 'price.currency', 'EUR');
  const price = prop(item, 'price.price', 0);
  const priceWithoutVat = prop(item, 'price.priceWithoutVat', 0);
  const correctPrice = isB2B ? priceWithoutVat : price;
  const priceReadable =
    correctPrice > 0
      ? `${correctPrice} ${getSymbolFromCurrency(currency)}`
      : 'Zadarmo';

  return {
    id: prop(item, 'payment_id'),
    name: prop(item, 'payment_name'),
    price: priceReadable,
  };
};
